// Copyright (C) 2022 LTTS
//
// SPDX-License-Identifier: MIT
import React from 'react';
import { Input, Button, Row, Col } from 'antd';
import Form from 'antd/lib/form';
import Text from 'antd/lib/typography/Text';
import { RouteComponentProps } from 'react-router';
import { Link, withRouter } from 'react-router-dom';
import Icon, { NumberOutlined } from '@ant-design/icons';
import { BackArrowIcon } from 'icons';
import { logoutAsync } from 'actions/auth-actions';
// import { validatePassword } from 'components/register-page/register-form';
import { useDispatch } from 'react-redux';
export interface LoginData {
    otpnumber: string;
    email:string;
}
interface Props {
    fetching: boolean;
    renderResendOPT(email: string): void;
    onSubmit(loginData: LoginData): void;
}

function LoginOTPFormComponent(props: Props & RouteComponentProps): JSX.Element {
    const { fetching, renderResendOPT, onSubmit } = props;
     const dispatch = useDispatch();
     const backtologin = (event: any) => {
            event.preventDefault();
            dispatch(logoutAsync());
        };
    return (
        <>
            <Form onFinish={onSubmit} autoComplete='off' className='login-form-otp'>
                <Row justify='space-between'>
                    <Icon onClick={(event) => backtologin(event)}
                        className='form-SSO'
                        component={() => (
                            <Link to='/auth/sso'>
                                <BackArrowIcon />
                            </Link>
                        )}
                    />
                </Row>
                <Row justify='space-between'>
                    <Col>
                        <p className='form-SSO'> SSO Login with OTP Verification </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text type='secondary' className='form-SSO1'>
                            Please check Your Mail and Enter your OTP
                        </Text>
                    </Col>
                </Row>
                <Form.Item
                    name='otpnumber'
                    rules={[
                        {
                            required: true,
                            message: 'Please eneter a OTP number',
                            pattern: new RegExp(/^[0-9]+$/),
                        },
                    ]}
                >
                    <Input
                        className='login-form-field'
                        suffix={<NumberOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />}
                        placeholder='Enter OTP'
                        autoComplete='off'
                        maxLength={6}
                    />
                </Form.Item>
                <Form.Item className='login-button-row'>
                    <Button
                        type='primary'
                        loading={fetching}
                        disabled={fetching}
                        htmlType='submit'
                        className='login-form-button'
                    >
                        OTP Verify
                    </Button>
                </Form.Item>
            </Form>
            <Form onFinish={renderResendOPT} autoComplete='off'>
                <Form.Item className='login-button-row'>
                    <Button
                        type='primary'
                        loading={fetching}
                        disabled={fetching}
                        htmlType='submit'
                        className='login-form-button'
                    >
                        Resend OTP
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default withRouter(LoginOTPFormComponent);
